import { render, staticRenderFns } from "./PropertySummary.vue?vue&type=template&id=c3bd2a9e&"
import script from "./PropertySummary.vue?vue&type=script&lang=js&"
export * from "./PropertySummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports